import { queueRestoreApi } from "./queueRestore.api";

export const { useGetQueueRestoresQuery, useLazyGetQueueRestoresQuery, useSaveQueueRestoreMutation } = queueRestoreApi;
